module.exports = __webpack_public_path__ + "img/caas4-m@2.b848b311.jpg";